var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.504883,
    y: 0.50293,
    width: 30.998,
    height: 30.998,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3371 10.668H10.6711C9.93481 10.668 9.33789 11.2649 9.33789 12.0012V20.0007C9.33789 20.7371 9.93481 21.334 10.6711 21.334H21.3371C22.0735 21.334 22.6704 20.7371 22.6704 20.0007V12.0012C22.6704 11.2649 22.0735 10.668 21.3371 10.668Z",
    stroke: "black",
    strokeWidth: 1.33325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6704 12.6678L16.6908 16.4676C16.485 16.5966 16.247 16.6649 16.0041 16.6649C15.7613 16.6649 15.5233 16.5966 15.3175 16.4676L9.33789 12.6678",
    stroke: "black",
    strokeWidth: 1.33325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6693c16750bbc81237215f1854267291.svg";
export { ForwardRef as ReactComponent };